import { lazy } from 'react';
import InitialPostDefault, { meta as InitialPostMeta } from './smart-time-analytics.mdx';
import RemoteWorkPostDefault, { meta as RemoteWorkPostMeta } from './mastering-remote-work.mdx';
import PomodoroPostDefault, { meta as PomodoroPostMeta } from './the-pomodoro-technique.mdx';
import ProductivityPostDefault, { meta as ProductivityPostMeta } from './team-productivity-hacks.mdx';

const posts = [
    {
        slug: 'smart-time-analytics',
        component: lazy(() => import('./smart-time-analytics.mdx')),
        meta: InitialPostMeta
    },
    {
        slug: 'mastering-remote-work',
        component: lazy(() => import('./mastering-remote-work.mdx')),
        meta: RemoteWorkPostMeta
    },
    {
        slug: 'the-pomodoro-technique',
        component: lazy(() => import('./the-pomodoro-technique.mdx')),
        meta: PomodoroPostMeta
    },
    {
        slug: 'team-productivity-hacks',
        component: lazy(() => import('./team-productivity-hacks.mdx')),
        meta: ProductivityPostMeta
    }
];

export default posts;
